<div class="module2">
    <div class="titles">
        <p class="text">
            Меня зовут Лена. У меня три разновозрастных ребенка: два сына (2016
            и 2023 г.р.) и дочь (2020 г.р.). Мне 38 лет и 12 из них я
            проработала в государственных структурах. Второй декрет превратил
            меня из бюрократа в самоучку-эксперта по детскому досугу. С каждым
            годом моя семья увеличивалась, мобильность в передвижениях таким
            составом сокращалась, а желание расширять кругозор и продолжать
            “путешествовать” по своему городу неимоверно росло. Начинала с
            банальных списков в Яндексе, а дальше погрузилась в мир, где каждый
            выход с детьми становится похож на экспедицию. Итак, да, с тремя
            детьми можно не только выжить, но и удивительным образом найти
            радость в этом хаосе.
        </p>
    </div>
</div>

<style>
    .module2 {
        /* width: fit-content; */
        margin: 0 auto;
        position: relative;
        background: linear-gradient(to top, #4f7942, #addfad);
        /* background-color: #ADDFAD;  */
        width: 100%;
    }

    .titles {
        /* position: absolute; */
        left: 0;
        right: 0;
        height: 100%;
        margin: 0 auto;
        color: #eaf4e5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .text {
        width: 100%;
        margin: 0 auto;
        display: block;
        text-align: left;
        text-shadow: 2px 2px 4px #000000;
    }

    @media (min-width: 1280px) { /*Ноутбук*/
        .module2 {
            height: 250px;
        }
        .titles {
            width: 50%;
        }
        .text {
            /* font-size: var(--theme-text-size-lg); */
            font-size: 20px;
            font-weight: 200;
        }
    }
    @media (max-width: 480px) { /*Телефон вертикаль*/
        .module2 {
            height: 550px;
        }
        .titles {
            width: 90%;
        }
        .text {
            font-size: 19px;
            font-weight: 200;
        }
    }
    @media (min-width: 481px) and (max-width: 833px) { /*Телефон горизонталь*/
        .module2 {
            height: 100%;
        }
        .titles {
            width: 90%;
        }
        .text {
            font-size: 20px;
            font-weight: 200;
        }
    }
    @media (min-width: 834px) and (max-width: 1023px) { /*Планшет*/
        .module2 {
            height: 50%;
        }
        .titles {
            width: 90%;
        }
        .text {
            font-size: 30px;
            font-weight: 200;
        }
    }
    @media (min-width: 1024px) and (max-width: 1279px){ /*Планшет2*/
        .module2 {
            height: 610px;
        }
        .titles {
            width: 90%;
        }
        .text {
            font-size: 35px;
            font-weight: 200;
        }
    }
</style>
